import { useMemo } from 'react'
import { AssessmentWorkflowPage } from './AssessmentWorkflowPage'
import { getAcquisitionChecklistOverview } from '../../lib/services/assessments'

const CATEGORY_ICONS: Record<string, string> = {
  FINANCIAL: '$',
  EQUIPMENT: 'E',
  STAFFING: 'S',
  MARKET: 'M',
  FACILITY: 'F',
  REGULATORY: 'R',
  IT: 'I',
}

export function AcquisitionAssessmentPage() {
  const overview = useMemo(() => getAcquisitionChecklistOverview(), [])

  return (
    <div className="mx-auto max-w-5xl space-y-5">
      {/* DD Checklist Overview */}
      <section className="v11-section p-5">
        <h2 className="text-sm font-black uppercase tracking-widest text-slate-500">
          Due-Diligence Checklist
        </h2>
        <p className="mt-1 text-xs text-slate-500">
          {overview.totalItems} items across {overview.categories.length} categories
          — green/yellow/red rating + photo + notes per item
        </p>
        <div className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3">
          {overview.categories.map((cat) => (
            <div
              key={cat.key}
              className="v11-dashboard-card flex items-start gap-3 p-3"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-xs font-bold text-slate-600">
                {CATEGORY_ICONS[cat.key] ?? '?'}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-bold text-slate-900">{cat.label}</p>
                <p className="text-xs text-slate-500">{cat.description}</p>
                <p className="mt-1 text-xs font-semibold text-[var(--brand-primary)]">
                  {cat.itemCount} items
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Standard workflow (create visit, execution list) */}
      <AssessmentWorkflowPage workflow="acquisition" />
    </div>
  )
}
